import request from '../../config/axiosConfig';
import {
  GET_LIST_USER_FEATURES, GET_USER_FEATURE_INFO, CREATE_USER_FEATURE,
  UPDATE_USER_FEATURE, DELETE_USER_FEATURE, LIST_FEATURES
} from '../../constants/apiEndPoint';

export const getListUserFeaturesRequest = async (data) => {
  const result = await request({ url: GET_LIST_USER_FEATURES, method: 'POST', data });
  return result?.data.data;
};

export const getUserFeatureInfoRequest = async (data) => {
  const result = await request({ url: GET_USER_FEATURE_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createUserFeatureRequest = async (data) => {
  const result = await request({ url: CREATE_USER_FEATURE, method: 'POST', data });
  return result?.data;
};

export const updateUserFeatureRequest = async (data) => {
  const result = await request({ url: UPDATE_USER_FEATURE, method: 'POST', data });
  return result?.data;
};

export const deleteUserFeatureRequest = async (data) => {
  const result = await request({ url: DELETE_USER_FEATURE, method: 'POST', data });
  return result?.data;
};

export const listFeaturesRequest = async (data) => {
  const result = await request({ url: LIST_FEATURES, method: 'POST', data });
  return result?.data.data;
};
